"use client";
import { useState, useEffect } from "react";

const useScrollOpacity = (initialOpacity = 0.2, finalOpacity = 1) => {
  const [opacity, setOpacity] = useState(initialOpacity);

  useEffect(() => {
    const handleScroll = () => {
      const DesktopScrollThreshold = 250;
      const MobileScrollThreshold = 50;

      // Get current viewport width
      const isMobile = window.innerWidth < 768;
      const threshold = isMobile
        ? MobileScrollThreshold
        : DesktopScrollThreshold;

      const currentScroll = window.scrollY;
      if (currentScroll > threshold) {
        setOpacity(finalOpacity);
      } else {
        // Calculate opacity based on scroll position
        const newOpacity =
          initialOpacity +
          (currentScroll / threshold) * (finalOpacity - initialOpacity);
        setOpacity(Math.min(newOpacity, finalOpacity));
      }
    };

    // Add resize listener to update on screen size changes
    window.addEventListener("resize", handleScroll, { passive: true });
    window.addEventListener("scroll", handleScroll, { passive: true });

    // Initial calculation
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [initialOpacity, finalOpacity]);

  return opacity;
};

export default useScrollOpacity;
